export default __webpack_public_path__ + "static/media/9.e9db5ad8.webp";